export const styles = {
  button: {
    background: '#004360',
    border: '1px solid #004360',
    borderRadius: '12px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '48px',
    width: '194px',
    cursor: 'pointer',
    '& div': {
      color: '#FFFFFF',
      fontSize: '16px',
      fontWeight: 700,
    },
    '&:hover': {
      background: '#FFFFFF',
      '& div': {
        color: '#004360',
      },
    },
    '@media screen and (max-width:768px)': {
      width: '100%',
      height: '40px',
    },
  },
}
